import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Portfolio from "@/components/site/Portfolio";
import Packages from "@/components/site/Packages";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-graphite-950 text-white overflow-x-hidden">
      <Nav />
      <Hero />
      <Marquee />
      <Portfolio />
      <Packages />
      <Process />
      <Testimonials />
      <QuoteForm />
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
